import { useLayoutEffect, useState } from 'react';

export const useWindowSize = (): { width: number; height: number } => {
  const [size, setSize] = useState([0, 0]);
  useLayoutEffect(() => {
    const updateSize = (): void => {
      setSize([window.innerWidth, window.innerHeight]);
    };

    window.addEventListener('resize', updateSize);
    updateSize();

    return () => window.removeEventListener('resize', updateSize);
  }, []);
  return { width: size[0] ?? 0, height: size[1] ?? 0 };
};
